import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { PanelWithCheck } from 'apps/auth/components/common/components/PanelWithCheck/PanelWithCheck';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import EnterYourReasonPopup from './EnterYourReasonPopup';
import { setUserAlreadySeenCancelPasscodeSurvey } from '../utils';

const FeedbackCancellationReasons = (props) => {
    const { submitButton } = usePageMessages();
    const { feedbackCancellationReasons } = useExtra();

    const popupRef = useRef(null);
    const [disabled, toggleDisable] = useState(true);
    const [selectedReason, setSelectedReason] = useState(null);

    const selectReason = (e, reason) => {
        e?.preventDefault?.();
        setSelectedReason(reason.reasonId === selectedReason?.reasonId ? null : reason);
        toggleDisable(reason?.isInputRequired || reason.reasonId === selectedReason?.reasonId);

        amplitude.getInstance().logEvent('Cancel Passcode Setup Reason Selected', { cancel_reason: reason.amplitudeDesc });

        if (reason?.isInputRequired) {
            e?.preventDefault();
            e?.stopPropagation();
            popupRef.current?.open(<EnterYourReasonPopup popupRef={popupRef} reason={reason} submitReason={submitReason} />);
        }
    };

    const submitReason = (e, reason, value) => {
        e?.preventDefault?.();
        amplitude.getInstance().logEvent('Cancel Passcode Setup Reason Submit Clicked', { cancel_reason: value });
        setUserAlreadySeenCancelPasscodeSurvey();
        popupRef.current?.close();
        props.toggleSpinner(true);
        window.location.href = AUTH_SEND_MAIN_LINK;
    };

    return (
        <>
            <HeaderPanel title={feedbackCancellationReasons.title} subtitle={feedbackCancellationReasons.subtitle} />
            {Array.isArray(feedbackCancellationReasons?.reasons) &&
                feedbackCancellationReasons.reasons.map((reason) => (
                    <PanelWithCheck
                        key={reason.reasonId}
                        mainText={reason.description}
                        id={'' + reason.reasonId}
                        selectedPanelId={'' + selectedReason?.reasonId}
                        onClick={(e) => selectReason(e, reason)}
                    />
                ))}
            <FixedBottomPanel isRightAligned>
                <Button
                    type="submit"
                    disabled={disabled}
                    raised={true}
                    caption={submitButton}
                    onClick={(e) => submitReason(e, selectedReason, selectedReason.amplitudeDesc)}
                />
            </FixedBottomPanel>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default connect(null, { toggleSpinner })(FeedbackCancellationReasons);
